import script from "./TablaOfertasVigentes.vue?vue&type=script&setup=true&lang=js"
export * from "./TablaOfertasVigentes.vue?vue&type=script&setup=true&lang=js"

import "./TablaOfertasVigentes.vue?vue&type=style&index=0&id=ed134126&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed134126"]])

export default __exports__